import React from "react";
import { motion } from "framer-motion";

const About = () => (
  <section className="py-24 bg-white, text-black">
    <div className="container mx-auto px-6">
      <div className="flex flex-wrap items-center">
        <motion.div
          className="w-full lg:w-2/3 mb-8 lg:mb-0"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <img
            src="/images/about-us.jpg"
            alt="Modern Kitchen Design"
            className="w-full h-auto max-h-[500px] object-cover rounded-lg shadow-lg"
          />
        </motion.div>
        <motion.div
          className="w-full lg:w-1/3 lg:pl-12"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <h2 className="text-4xl font-bold mb-6">關於奕發</h2>
          <h3 className="text-2xl font-semibold mb-4">About</h3>
          <p className="text-lg mb-6">
            奕發興業有限公司成立於西元1991年，專注於各式高品質廚具櫥櫃
            門板、板材的製造。從早期家戶必備的美耐板彎曲檯面、門板，到
            各大建案標配的高光結烤門板及如今更開發獨家的霧烤透心硬化門 板。
          </p>
          <p className="text-lg mb-6">
            奕發憑藉著30多年來專業廚具櫥櫃門板材料的製造經驗經驗及技術
            並堅持創新，開發多樣的門板材質及色系，以期符合不同時代 市場的需求。
          </p>
          <p className="text-lg mb-6">
            我們擁有多條完整的生產線，在提供充足的產能之餘亦不斷研發多
            元的門板樣式及提供數百種不同顏色供挑選。{" "}
          </p>

          <p className="text-lg mb-6">
            穩定的產能及庫存讓我們長期維持穩定的供貨速度，讓每個趕工的
            您都能及時交貨。{" "}
          </p>
          <p className="text-lg mb-6">
            “ The quality you can trust, the luxury you can afford.”{" "}
          </p>

          <motion.button
            className="bg-accent text-white px-6 py-3 rounded-full hover:bg-opacity-80 transition duration-300"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            了解更多
          </motion.button>
        </motion.div>
      </div>
    </div>
  </section>
);

export default About;
